export const mapSettings = [
    {
        id: 0,
        name: 'roadmap',
    },
    {
        id: 1,
        name: 'roadmap_terrain',
    },
    {
        id: 2,
        name: 'satellite',
    },
    {
        id: 3,
        name: 'satellite_labels',
    },
    {
        id: 4,
        name: 'map_id',
    },
];
